module.exports = __webpack_public_path__ + "static/media/banner.94af64e2.svg";